import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const ItemInfomation = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 flex flex-col gap-5 rounded-md p-5 duration-150'>

      <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
        {store} 재고 관리 현황
      </div>

      <div className='flex flex-col gap-3'>
        <div className='flex justify-between'>
          <div className='flex gap-3 justify-center items-center'>
            {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
            <p>추가 처리</p>
          </div>
          <div>
            <p className='pt-[5px] tracking-wider'>{`${NumberConvert(Number(data.data0))} 건`}</p>
          </div>
        </div>

        <div className='flex justify-between'>
          <div className='flex gap-3 justify-center items-center'>
            {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
            <p>수정 처리</p>
          </div>
          <div>
            <p className='pt-[5px] tracking-wider'>{`${NumberConvert(Number(data.data1))} 건`}</p>
          </div>
        </div>

        <div className='flex justify-between'>
          <div className='flex gap-3 justify-center items-center'>
            {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
            <p>삭제 처리</p>
          </div>
          <div>
            <p className='pt-[5px] tracking-wider'>{`${NumberConvert(Number(data.data2))} 건`}</p>
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default ItemInfomation